// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2J1a-","cell":"ColumnAccessor_cell__1jOR8","firstCellAccent":"ColumnAccessor_firstCellAccent__32lmD"};